import React, { useState } from 'react';
import TextInput from "./TextInput";
import { useField } from "formik";
import { PdsStatusIndicator } from "@principal/design-system-react";
import _ from "lodash";
import { PdsIconEye, PdsIconEyeOff } from "@principal/design-system-icons-react";

type PasswordInputProps = {
    id: string,
    name?: string,
    label?: string,
    changeCallback?: Function,
}

const PasswordInput = (props: PasswordInputProps) => {
    const [showPassword, setShowPassword] = useState(false)
    const name = props.name ? props.name : _.camelCase(props.id);
    const [, meta] = useField(name);
    const value = meta.value;

    return (
        <div>
            <TextInput id={props.id}
                       name={props.name}
                       label={props.label}
                       required={true}
                       inputProps={{ type: showPassword ? 'text' : 'password'}}
                       rightContent={<span onClick={() => setShowPassword(!showPassword)}>
                           {showPassword ? <PdsIconEyeOff/> : <PdsIconEye/>}
                       </span>}
                       changeCallback={props.changeCallback}
                       maxLength={15}
                       validate={(value) => {
                           const isValid = hasUppercase(value) && hasLowercase(value) && hasNumber(value) && hasSpecialCharacter(value) && hasValidLength(value);
                           return isValid ? '' : 'Password does not align with security criteria.';
                       }}/>
            <PdsStatusIndicator variant={hasUppercase(value) ? 'default' : 'warning'}>Has at least 1 uppercase letter</PdsStatusIndicator>
            <PdsStatusIndicator variant={hasLowercase(value) ? 'default' : 'warning'}>Has at least 1 lowercase letter</PdsStatusIndicator>
            <PdsStatusIndicator variant={hasNumber(value) ? 'default' : 'warning'}>Has at least 1 number</PdsStatusIndicator>
            <PdsStatusIndicator variant={hasSpecialCharacter(value) ? 'default' : 'warning'}>Has at least 1 special character</PdsStatusIndicator>
            <PdsStatusIndicator variant={hasValidLength(value) ? 'default' : 'warning'}>Is between the length of 8 and 15 characters</PdsStatusIndicator>
        </div>
    );

    function hasUppercase(value: string) {
        return /[A-Z]/.test(value);
    }

    function hasLowercase(value: string) {
        return /[a-z]/.test(value);
    }

    function hasNumber(value: string) {
        return /[0-9]/.test(value);
    }

    function hasSpecialCharacter(value: string) {
        return /\W/.test(value);
    }

    function hasValidLength(value: string) {
        return value?.length >= 8 && value?.length <= 15;
    }
};
export default PasswordInput;